import React, { Fragment, useEffect,useState } from 'react';
import '../Style/Arsa.css';
import { Outlet } from 'react-router-dom';
import {Container,Grid,Typography} from '@mui/material'
import {useSelector} from 'react-redux';
import ProjectItems from '../helpers/ProjectItems';
import AdPtojrcts from '../reklam/AdPtojrcts';
import Comunication from './Comunication';
import ComunicationPhone from './ComunicationPhone';
import ComunicationEmail from './ComunicationEmail';

function Arsa() {
  const [proje, setProje] = useState([])
  const {dataItems} = useSelector ((store) => store.dataR)
  useEffect(() => {
    const newDataItem=dataItems.filter((item) => item.type==='Arsa')
    setProje(newDataItem)
  },[dataItems])
  return (
  <Fragment>
    <Comunication/>
    <ComunicationPhone/>
    <ComunicationEmail/>
      <AdPtojrcts/>
      <Container sx={{marginBottom:3,marginTop:2}}>
      <Typography variant='h4' component='h4' sx={{marginBottom:2, textAlign:'center'}} className='arsaWriting'>Arsa Projelerimiz</Typography>
        <Grid sx={{marginBottom:3}}>
          <Grid sx={{display:'flex', flexDirection:'row',flexWrap:'wrap', justifyContent:'center',gap:'20px'}}>
              {proje.map((Item, key) => {
                return(
                  <ProjectItems
                  key={key}
                  {...Item}
                  loading='lazy'
                  />
                )
              })}
          </Grid>
        </Grid>
      </Container>
      <Outlet/>
    </Fragment>
  )
}

export default Arsa;